import { render, staticRenderFns } from "./ConfigureProfilModal.vue?vue&type=template&id=6dfb09ae&scoped=true&"
import script from "./ConfigureProfilModal.vue?vue&type=script&lang=js&"
export * from "./ConfigureProfilModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfb09ae",
  null
  
)

export default component.exports